import * as React from 'react';
import {Helmet} from 'react-helmet';

import styles from './pre-auth-layout.module.css';

type Props = {
    children: React.ReactNode;
    bodyId: string;
    backgroundColor?: string;
    imageLeft?: React.ReactNode;
};

PreAuthLayout.defaultProps = {
    bodyId: 'pre-auth',
};

export function PreAuthLayout({imageLeft, backgroundColor, children, bodyId}: Props) {
    // Set the page's body id when first mounting.
    React.useEffect(() => {
        const pageBody = document.querySelector('body');
        if (pageBody && pageBody.id !== bodyId) {
            pageBody.id = bodyId;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles['pre-auth-layout']}>
            <Helmet>
                <meta name='viewport' content='width=device-width,initial-scale=1' />
            </Helmet>
            <div
                style={backgroundColor ? {backgroundColor: backgroundColor} : undefined}
                className={
                    backgroundColor ? styles['left-column--with-background'] : styles['left-column']
                }
            >
                {imageLeft}
            </div>
            <div className={styles['right-column']}>
                <div className={styles['logo']}>
                    <a href='https://www.nutshell.com/home'>
                        <img src='/include/images/nutshell-logo-full-color.svg' alt='' />
                    </a>
                </div>
                {children}
            </div>
        </div>
    );
}
